function getLang() {
    return $('html').attr('lang');
}